export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CART_SAVE_FACTURACION ="CART_SAVE_FACTURACION";
export const CART_SAVE_PAYMENT = "CART_SAVE_PAYMENT";
export const CART_EMPY = "CART_EMPY";
export const DECREMENT_TO_CART ="DECREMENT_TO_CART";
export const ORDER_CREATE_RESET ="ORDER_CREATE_RESET";